import { api } from "@/lib/api";
import { getToken } from "@/lib/store";

export const S = {
  list: () => api.get("/sessions").then((r) => r.data.sessions),
  create: (b) => api.post("/sessions", b).then((r) => r.data),
  join: (code) => api.post("/sessions/join", { code }).then((r) => r.data),
  get: (id, since = -1) => api.get(`/sessions/${id}`, { params: { since } }).then((r) => r.data),
  patch: (id, b) => api.put(`/sessions/${id}`, b).then((r) => r.data),
  notes: (id, text) => api.put(`/sessions/${id}/notes`, { text }),
  invite: (id, email, role) => api.post(`/sessions/${id}/invite`, { email, role }).then((r) => r.data),
  role: (id, uid, role) => api.put(`/sessions/${id}/members/${uid}`, { role }),
  remove: (id, uid) => api.delete(`/sessions/${id}/members/${uid}`),
  del: (id) => api.delete(`/sessions/${id}`),
  messages: (id, after = "") => api.get(`/sessions/${id}/messages`, { params: { after } }).then((r) => r.data.messages),
  send: (id, text) => api.post(`/sessions/${id}/messages`, { text }).then((r) => r.data),
  callJoin: (id) => api.post(`/sessions/${id}/call/join`).then((r) => r.data),
  callLeave: (id) => api.post(`/sessions/${id}/call/leave`),
  signal: (id, to, type, payload) => api.post(`/sessions/${id}/call/signal`, { to, type, payload }),
  signals: (id) => api.get(`/sessions/${id}/call/signals`).then((r) => r.data),
  playback: (id, b) => api.put(`/sessions/${id}/playback`, b).then((r) => r.data),
  editing: (id, item_id, field) => api.put(`/sessions/${id}/editing`, { item_id, field }),
  setlistUrl: (id) => `${process.env.REACT_APP_BACKEND_URL}/api/sessions/${id}/setlist.pdf?auth=${getToken()}`,
  setlistSave: (id) => api.get(`/sessions/${id}/setlist.pdf`, { params: { save: 1 } }).then((r) => r.data),
  setlistEmail: (id) => api.post(`/sessions/${id}/setlist/email`).then((r) => r.data),
  activity: () => api.get("/sessions/activity").then((r) => r.data.sessions),
  propose: (id, b) => api.post(`/sessions/${id}/proposals`, b).then((r) => r.data),
  vote: (id, pid, vote) => api.put(`/sessions/${id}/proposals/${pid}/vote`, { vote }),
  confirmProposal: (id, pid) => api.put(`/sessions/${id}/proposals/${pid}/confirm`).then((r) => r.data),
  deleteProposal: (id, pid) => api.delete(`/sessions/${id}/proposals/${pid}`),
  share: (id) => api.post(`/sessions/${id}/share`).then((r) => r.data.token),
  unshare: (id) => api.delete(`/sessions/${id}/share`),
  comments: (id, fid) => api.get(`/sessions/${id}/takes/${fid}/comments`).then((r) => r.data.comments),
  addComment: (id, fid, b) => api.post(`/sessions/${id}/takes/${fid}/comments`, b).then((r) => r.data),
  resolveComment: (id, cid, resolved) => api.put(`/sessions/${id}/comments/${cid}/resolve`, { resolved }).then((r) => r.data),
  deleteComment: (id, cid) => api.delete(`/sessions/${id}/comments/${cid}`),
  icsUrl: (id, pid) => `${process.env.REACT_APP_BACKEND_URL}/api/sessions/${id}/calendar.ics?auth=${getToken()}${pid ? `&proposal=${pid}` : ""}`,
};

export const O = { reminder: (b) => api.post("/office/reminder", b).then((r) => r.data) };

export const V = {
  list: () => api.get("/vault/files").then((r) => r.data.files),
  patch: (id, b) => api.put(`/vault/files/${id}`, b),
  del: (id) => api.delete(`/vault/files/${id}`),
  url: (id, download = false) => `${process.env.REACT_APP_BACKEND_URL}/api/vault/files/${id}/content?auth=${getToken()}${download ? "&download=1" : ""}`,
};

export const audioDuration = (src) => new Promise((res) => {
  const a = document.createElement("audio");
  a.preload = "metadata";
  const done = (v) => { a.src = ""; res(v); };
  a.onloadedmetadata = () => done(isFinite(a.duration) ? a.duration : 0);
  a.onerror = () => done(0);
  a.src = src;
});

export async function uploadFile(file, { session_id = null, tags = [], onProgress } = {}) {
  const { data: init } = await api.post("/vault/upload/init", { name: file.name, content_type: file.type || "application/octet-stream", size: file.size, session_id, tags });
  const CH = init.chunk_size, total = Math.ceil(file.size / CH);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("index", i);
    fd.append("chunk", file.slice(i * CH, (i + 1) * CH), "chunk");
    let attempt = 0;
    for (;;) {
      try { await api.post(`/vault/upload/${init.upload_id}/chunk`, fd, { timeout: 90000 }); break; }
      catch (e) {
        attempt++;
        if (attempt >= 4 || (e.response && e.response.status < 500 && e.response.status !== 413 && e.response.status !== 429)) { e.message = `chunk ${i + 1}/${total} ${e.response ? `HTTP ${e.response.status}` : e.message}`; throw e; }
        await new Promise((r) => setTimeout(r, 800 * attempt));
      }
    }
    onProgress?.(Math.round(((i + 1) / total) * 92));
  }
  const { data } = await api.post(`/vault/upload/${init.upload_id}/complete`, null, { timeout: 300000 });
  onProgress?.(100);
  return data;
}
